import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = {
    key: "company-permission-list",
    class: "clearfix"
};
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h2", null, "Company Access", -1 /* HOISTED */);
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = {
    key: "new-permission",
    class: "clearfix"
};
const _hoisted_6 = { class: "clearfix" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_10 = { class: "float-end float-start-sm" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Add", -1 /* HOISTED */);
const _hoisted_13 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* HOISTED */);
const _hoisted_15 = {
    key: "edit-permission",
    class: "clearfix"
};
const _hoisted_16 = { class: "clearfix" };
const _hoisted_17 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_20 = { class: "float-end float-start-sm" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Update", -1 /* HOISTED */);
const _hoisted_23 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
const _hoisted_24 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Cancel", -1 /* HOISTED */);
const _hoisted_25 = { class: "clearfix" };
const _hoisted_26 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_27 = { class: "input-group top_search" };
const _hoisted_28 = { class: "input-group-btn" };
const _hoisted_29 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* HOISTED */);
const _hoisted_30 = [
    _hoisted_29
];
const _hoisted_31 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-8"
};
const _hoisted_32 = { class: "float-end float-start-sm" };
const _hoisted_33 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-plus" }, null, -1 /* HOISTED */);
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("span", { class: "hidden-xs" }, " Grant Access", -1 /* HOISTED */);
const _hoisted_35 = { class: "col-xs-12 col-sm-12" };
const _hoisted_36 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_37 = { class: "table table-hover small bottom0 pw100" };
const _hoisted_38 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center w40 no-min-width" }),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tCompany\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tSite\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-center" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tAuthorized Systems\r\n\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\tGranted On\r\n\t\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_39 = ["onClick"];
const _hoisted_40 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* HOISTED */);
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-lock" }, null, -1 /* HOISTED */);
const _hoisted_42 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* HOISTED */);
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("span", { class: "fa fa-refresh" }, null, -1 /* HOISTED */);
const _hoisted_44 = { key: 0 };
const _hoisted_45 = ["onClick"];
const _hoisted_46 = { key: 1 };
const _hoisted_47 = { class: "text-center text-uppercase" };
const _hoisted_48 = { key: 0 };
const _hoisted_49 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center",
    colspan: "5"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_50 = [
    _hoisted_49
];
const _hoisted_51 = { class: "data-grid-footer clearfix detached pw100" };
const _hoisted_52 = {
    key: "system-permission-list",
    class: "clearfix"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_form_select = _resolveComponent("b-form-select");
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_button_group = _resolveComponent("b-button-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _component_UserSystemAccessVue = _resolveComponent("UserSystemAccessVue");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CollapsibleForm, null, {
                title: _withCtx(() => [
                    _hoisted_3
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                        _withDirectives(_createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createVNode(_component_b_form_select, {
                                        modelValue: _ctx.companyId,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.companyId) = $event)),
                                        options: _ctx.companies
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_b_form_select, {
                                        modelValue: _ctx.siteId,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.siteId) = $event)),
                                        options: _ctx.filteredSites
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "primary",
                                            onClick: _ctx.add
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_11,
                                                _hoisted_12
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "outline-secondary",
                                            onClick: _ctx.toggleAccessPanel
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_13,
                                                _hoisted_14
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                    ])
                                ])
                            ])
                        ], 512 /* NEED_PATCH */), [
                            [_vShow, _ctx.addingPermission]
                        ]),
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                    _createVNode(_component_b_form_select, {
                                        modelValue: _ctx.companyId,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.companyId) = $event)),
                                        options: _ctx.companies
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_b_form_select, {
                                        modelValue: _ctx.siteId,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.siteId) = $event)),
                                        options: _ctx.filteredSites
                                    }, null, 8 /* PROPS */, ["modelValue", "options"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "primary",
                                            onClick: _ctx.updatePermission
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_21,
                                                _hoisted_22
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "outline-secondary",
                                            onClick: _ctx.cancelEdit
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_23,
                                                _hoisted_24
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                    ])
                                ])
                            ])
                        ], 512 /* NEED_PATCH */), [
                            [_vShow, _ctx.editingPermission]
                        ]),
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                    _createVNode(_component_b_form_input, {
                                        type: "text",
                                        modelValue: _ctx.query.keywords,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.keywords) = $event)),
                                        modelModifiers: { trim: true },
                                        placeholder: "Search for...",
                                        onKeyup: _withKeys(_ctx.search, ["enter"]),
                                        required: ""
                                    }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                                    _createTextVNode(),
                                    _createElementVNode("span", _hoisted_28, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-default",
                                            onClick: _cache[5] || (_cache[5] =
                                                //@ts-ignore
                                                (...args) => (_ctx.search && _ctx.search(...args)))
                                        }, _hoisted_30)
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.companiesLoaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                        _createVNode(_component_b_button, {
                                            type: "button",
                                            variant: "primary",
                                            onClick: _ctx.toggleAccessPanel
                                        }, {
                                            default: _withCtx(() => [
                                                _hoisted_33,
                                                _hoisted_34
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["onClick"])
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ], 512 /* NEED_PATCH */), [
                            [_vShow, !_ctx.addingPermission && !_ctx.editingPermission]
                        ]),
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("table", _hoisted_37, [
                                    _hoisted_38,
                                    _createTextVNode(),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                onClick: ($event) => (_ctx.selectForEdit(item)),
                                                style: _normalizeStyle({ backgroundColor: _ctx.editingPermission === item ? '#d1ecf1 !important' : '', cursor: 'pointer' })
                                            }, [
                                                _createElementVNode("td", {
                                                    class: "text-center",
                                                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => { }, ["stop"]))
                                                }, [
                                                    _createVNode(_component_b_button_group, null, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown, {
                                                                variant: "outline-secondary dots",
                                                                size: "sm",
                                                                onClick: ($event) => (_ctx.view(item))
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    (item.whenGrantedAccessToAllSystems == null)
                                                                        ? (_openBlock(), _createBlock(_component_b_dropdown_item, {
                                                                            key: 0,
                                                                            onClick: ($event) => (_ctx.view(item))
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _hoisted_40,
                                                                                _createTextVNode(" Edit Authorized Systems\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                            ]),
                                                                            _: 2 /* DYNAMIC */
                                                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                                                                        : _createCommentVNode("v-if", true),
                                                                    _createTextVNode(),
                                                                    _createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.toggleAccessToAllSystems(item))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _hoisted_41,
                                                                            _createTextVNode(" " + _toDisplayString(item.whenGrantedAccessToAllSystems == null ? "Grant Access to All" : "Allow to Set Individual Permissions"), 1 /* TEXT */)
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                                    _createTextVNode(),
                                                                    _createVNode(_component_b_dropdown_divider),
                                                                    _createTextVNode(),
                                                                    _createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.purge(item))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _hoisted_42,
                                                                            _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                                                                    _createTextVNode(),
                                                                    _withDirectives(_createVNode(_component_b_dropdown_item, {
                                                                        onClick: ($event) => (_ctx.restore(item))
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _hoisted_43,
                                                                            _createTextVNode(" Restore\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]), [
                                                                        [_vShow, item.whenDeleted]
                                                                    ])
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("td", null, [
                                                    (item.whenGrantedAccessToAllSystems == null)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                                            _createElementVNode("a", {
                                                                href: "#",
                                                                onClick: _withModifiers(($event) => (_ctx.view(item)), ["stop", "prevent"])
                                                            }, _toDisplayString(item.companyName), 9 /* TEXT, PROPS */, _hoisted_45)
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(item.companyName), 1 /* TEXT */))
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("td", null, _toDisplayString(item.siteId ? item.siteName : 'All'), 1 /* TEXT */),
                                                _createTextVNode(),
                                                _createElementVNode("td", _hoisted_47, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass({
                                                            'badge badge-danger': !item.numberOfSystems && !item.whenGrantedAccessToAllSystems,
                                                            'badge badge-success': item.whenGrantedAccessToAllSystems,
                                                            'badge badge-warning': item.numberOfSystems
                                                        })
                                                    }, _toDisplayString(item.whenGrantedAccessToAllSystems ? 'All' : (item.numberOfSystems || 'None')), 3 /* TEXT, CLASS */)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("td", null, _toDisplayString(_ctx.getFormattedDate(item.whenCreated)), 1 /* TEXT */)
                                            ], 12 /* STYLE, PROPS */, _hoisted_39));
                                        }), 256 /* UNKEYED_FRAGMENT */))
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("tfoot", null, [
                                        (_ctx.noData)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_48, _hoisted_50))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_51, [
                                _createVNode(_component_b_pagination, {
                                    class: "float-end",
                                    modelValue: _ctx.query.pageNo,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.query.pageNo) = $event)),
                                    "per-page": _ctx.query.pageSize,
                                    "total-rows": _ctx.data.recordCount,
                                    "hide-ellipsis": true,
                                    disabled: _ctx.working
                                }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                            ])
                        ], 512 /* NEED_PATCH */), [
                            [_vShow, _ctx.searchAttempted]
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            })
        ], 512 /* NEED_PATCH */), [
            [_vShow, !_ctx.displaySystemPermissions]
        ]),
        _createTextVNode(),
        _withDirectives(_createElementVNode("div", _hoisted_52, [
            _createVNode(_component_UserSystemAccessVue, {
                filter: _ctx.systemAccessFilter,
                onSystemsUpdated: _ctx.reload
            }, null, 8 /* PROPS */, ["filter", "onSystemsUpdated"])
        ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.displaySystemPermissions]
        ])
    ]));
}
